import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import BrandMark from "../components/BrandMark";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    const r = await login(email.trim(), password);
    setBusy(false);
    if (!r.ok) return setError(r.error);
    nav(r.user.role === "employee" ? "/kitchen" : "/");
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-background">
      <div className="hidden md:block relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1569864358642-9d1684040f43?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-background/75 backdrop-blur-[2px]" />
        <div className="relative h-full w-full flex flex-col justify-between p-12">
          <BrandMark size="lg" />
          <div className="max-w-md">
            <div className="label-eyebrow mb-3">Operating System</div>
            <h2 className="font-display text-3xl font-light leading-tight">
              One unified platform — kitchen floor to invoice, on every device.
            </h2>
            <div className="mt-8 h-px w-16 bg-primary" />
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-sm">
          <div className="md:hidden mb-10">
            <BrandMark size="md" />
          </div>

          <h1 className="font-display text-3xl font-light tracking-tight">Welcome back</h1>
          <p className="text-muted-foreground text-sm mt-2 mb-8">Sign in to your operating system.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="label-eyebrow mb-2 block">Email</label>
              <input
                type="email" autoComplete="email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                className="h-12 w-full rounded-xl border border-input bg-card px-4 text-base focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary"
                placeholder="you@macaronbypatisse.com"
              />
            </div>
            <div>
              <label className="label-eyebrow mb-2 block">Password</label>
              <input
                type="password" autoComplete="current-password" required
                value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="h-12 w-full rounded-xl border border-input bg-card px-4 text-base focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary"
              />
            </div>
            {error && (
              <div data-testid="login-error" className="text-sm text-destructive bg-destructive/5 border border-destructive/20 rounded-lg px-3 py-2">
                {error}
              </div>
            )}
            <button
              type="submit" disabled={busy}
              data-testid="login-submit-btn"
              className="h-12 w-full rounded-xl bg-foreground text-background font-medium hover:bg-foreground/90 disabled:opacity-60 active:scale-[0.99]"
            >
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
